(function () {

  var wrapper =
    document.getElementById('obd-product-compare');

  if (!wrapper) return;


  /*
   * =========================================================
   * DEFAULT: HIDE CTA
   * =========================================================
   *
   * Only products found in AUTEL_COMPARE_DATA.DATA
   * are allowed to display this CTA.
   */

  wrapper.style.display = 'none';

  wrapper.setAttribute(
    'data-compare-ready',
    'false'
  );


  var productTitle =
    wrapper.getAttribute('data-product-title') || '';

  var productHandle =
    wrapper.getAttribute('data-product-handle') || '';

  var button =
    document.getElementById('obd-compare-button');

  var description =
    document.getElementById('obd-compare-description');

  if (!button) return;

/* =========================================================
   CURRENT PRODUCT MODEL
   优先根据当前 URL 匹配 AUTEL_COMPARE_DATA 中的 Link
========================================================= */

function detectModelFromLink() {

  if (
    !window.AUTEL_COMPARE_DATA ||
    !window.AUTEL_COMPARE_DATA.DATA
  ) {
    return '';
  }

  var DATA = window.AUTEL_COMPARE_DATA.DATA;

  var currentPath =
    window.location.pathname
      .replace(/\/+$/, '')
      .toLowerCase();

  var models = Object.keys(DATA);

  for (var i = 0; i < models.length; i++) {

    var model = models[i];

    var productLink =
      DATA[model] &&
      DATA[model].Link;

    if (!productLink) {
      continue;
    }

    try {

      var linkPath =
        new URL(
          productLink,
          window.location.origin
        ).pathname
          .replace(/\/+$/, '')
          .toLowerCase();

      if (linkPath === currentPath) {
        return model;
      }

    } catch (e) {}

  }

  return '';
}

var currentModel =
  detectModelFromLink();
  /*
   * =========================================================
   * REMOVE "SECONDS AGO" / "MINUTES AGO"
   * =========================================================
   */

  function isRelativeTimeText(text) {

    var value =
      String(text || '')
        .trim()
        .toLowerCase();

    if (!value) return false;

    return (
      /^\d+\s*seconds?\s+ago$/.test(value) ||
      /^\d+\s*minutes?\s+ago$/.test(value) ||
      /^\d+\s*hours?\s+ago$/.test(value) ||
      /^a\s+few\s+seconds\s+ago$/.test(value) ||
      /^just\s+now$/.test(value)
    );

  }


  function removeInjectedTimeText() {

    Array.from(
      wrapper.childNodes
    ).forEach(function (node) {

      if (
        node.nodeType === Node.TEXT_NODE &&
        isRelativeTimeText(node.textContent)
      ) {

        node.remove();

      }

    });

  }


  removeInjectedTimeText();


  var timeObserver =
    new MutationObserver(function () {

      removeInjectedTimeText();

    });


  timeObserver.observe(
    wrapper,
    {
      childList: true,
      characterData: true,
      subtree: false
    }
  );


  window.setTimeout(
    removeInjectedTimeText,
    300
  );

  window.setTimeout(
    removeInjectedTimeText,
    1000
  );

  window.setTimeout(
    removeInjectedTimeText,
    3000
  );


  /*
   * =========================================================
   * NORMALIZE MODEL NAME
   * =========================================================
   */

  function normalize(value) {

    return String(value || '')

      .toUpperCase()

      .replace(/™/g, '')

      .replace(/®/g, '')

      .replace(/[–—]/g, '-')

      .replace(/\s+/g, ' ')

      .trim();

  }


  function compact(value) {

    return normalize(value)

      .replace(/[\s\-]+/g, '');

  }


  /*
   * =========================================================
   * MODEL ALIASES
   * =========================================================
   *
   * These only handle different ways a product title
   * may write the same model.
   *
   * The final model MUST still exist in
   * AUTEL_COMPARE_DATA.DATA.
   */

  var aliases = [

    {
      compareModel: 'MK906S Pro2-TS',

      names: [
        'MK906S PRO2-TS',
        'MK906S PRO 2-TS',
        'MK906S PRO II TS',
        'MK906S PRO II-TS'
      ]
    },

    {
      compareModel: 'MS908S Pro II',

      names: [
        'MS908S PRO II',
        'MS908S PRO 2',
        'MS908S PROII'
      ]
    },

    {
      compareModel: 'MK908 II',

      names: [
        'MK908 II',
        'MK908 2',
        'MK908II'
      ]
    },

    {
      compareModel: 'Elite II Pro',

      names: [
        'ELITE II PRO',
        'ELITE 2 PRO',
        'ELITE IIPRO'
      ]
    },

    {
      compareModel: 'Ultra Lite S',

      names: [
        'ULTRA LITE S',
        'ULTRALITE S',
        'ULTRA LITES'
      ]
    },

    {
      compareModel: 'Ultra S2',

      names: [
        'ULTRA S2',
        'ULTRAS2'
      ]
    }

  ];


  /*
   * =========================================================
   * DETECT MODEL FROM AUTEL_COMPARE_DATA
   * =========================================================
   */

  function detectModel(title, compareData) {

    var normalizedTitle =
      normalize(title);

    var dataModels =
      Object.keys(compareData || {});


    /*
     * ---------------------------------------------------------
     * 1. CHECK ALIASES
     * ---------------------------------------------------------
     */

    for (
      var a = 0;
      a < aliases.length;
      a++
    ) {

      var aliasGroup =
        aliases[a];


      /*
       * IMPORTANT:
       * Alias model must actually exist
       * inside AUTEL_COMPARE_DATA.DATA.
       */

      var actualDataModel =
        dataModels.find(function (model) {

          return (
            compact(model) ===
            compact(aliasGroup.compareModel)
          );

        });


      if (!actualDataModel) {
        continue;
      }


      for (
        var n = 0;
        n < aliasGroup.names.length;
        n++
      ) {

        if (

          compact(normalizedTitle)

            .indexOf(

              compact(
                aliasGroup.names[n]
              )

            ) !== -1

        ) {

          return actualDataModel;

        }

      }

    }


    /*
     * ---------------------------------------------------------
     * 2. CHECK ALL MODELS DIRECTLY FROM COMPARE DATA
     * ---------------------------------------------------------
     *
     * Longer model names are checked first.
     *
     * Example:
     *
     * MX808S-TS
     *
     * must be checked before:
     *
     * MX808S
     */

    dataModels.sort(function (a, b) {

      return (
        compact(b).length -
        compact(a).length
      );

    });


    for (
      var i = 0;
      i < dataModels.length;
      i++
    ) {

      var model =
        dataModels[i];


      if (

        compact(normalizedTitle)

          .indexOf(
            compact(model)
          ) !== -1

      ) {

        return model;

      }

    }


    return '';

  }


  /*
   * =========================================================
   * INITIALIZE COMPARE CTA
   * =========================================================
   */

  function initCompareCTA(attempt) {

    attempt = attempt || 0;


    /*
     * Wait for autel-compare-data.js
     */

    if (
      !window.AUTEL_COMPARE_DATA ||
      !window.AUTEL_COMPARE_DATA.DATA
    ) {

      /*
       * Keep hidden while waiting.
       */

      wrapper.style.display = 'none';


      /*
       * Retry for up to approximately 5 seconds.
       */

      if (attempt < 50) {

        window.setTimeout(
          function () {

            initCompareCTA(
              attempt + 1
            );

          },
          100
        );

      }

      return;

    }


    var compareData =
      window.AUTEL_COMPARE_DATA.DATA;


var detectedModel =
  detectModelFromLink() ||
  detectModel(
    productTitle,
    compareData
  );


    /*
     * =========================================================
     * MODEL NOT FOUND IN AUTEL_COMPARE_DATA
     * =========================================================
     */

    if (!detectedModel) {

      wrapper.style.display =
        'none';


      wrapper.removeAttribute(
        'data-detected-model'
      );


      wrapper.setAttribute(
        'data-compare-ready',
        'false'
      );


      return;

    }


    /*
     * =========================================================
     * MODEL FOUND IN AUTEL_COMPARE_DATA
     * =========================================================
     */

    button.textContent =
      'Compare ' +
      detectedModel +
      ' →';


    if (description) {

      description.textContent =
        'Compare ' +
        detectedModel +
        ' with similar Autel scanners side by side.';

    }


    var compareURL =
      '/pages/autel-scanner-comparison' +
      '?model=' +
      encodeURIComponent(
        detectedModel
      );


    if (productHandle) {

      compareURL +=
        '&handle=' +
        encodeURIComponent(
          productHandle
        );

    }


    button.href =
      compareURL;
button.target = '_blank';
button.rel = 'noopener noreferrer';

    wrapper.setAttribute(
      'data-detected-model',
      detectedModel
    );


    wrapper.setAttribute(
      'data-compare-ready',
      'true'
    );


    /*
     * ONLY NOW DISPLAY CTA
     */

    wrapper.style.display = '';


    removeInjectedTimeText();

  }


  /*
   * Start
   */

  initCompareCTA(0);


})();



/* =========================================
   GA4 - Product Compare CTA Tracking
========================================= */

document.addEventListener(
  'click',
  function (event) {

    var button =
      event.target.closest(
        '#obd-compare-button'
      );

    if (!button) return;


    var box =
      document.querySelector(
        '#obd-product-compare'
      );


    if (
      typeof gtag !== 'function'
    ) {
      return;
    }


    gtag(
      'event',
      'compare_click',
      {

        product_name:
          box
            ? box.dataset.productTitle || ''
            : '',

        product_handle:
          box
            ? box.dataset.productHandle || ''
            : ''

      }
    );

  }
);